module.exports = __webpack_public_path__ + "img/send_invoice_disabled.1fc89b98.svg";